import { all, call, put, takeLatest } from "redux-saga/effects"

import { generateTree } from "utils/utils"

import { GET_TEAMS_WATCHER } from "./constants"

import { getTeamsSuccess, getTeamsFailed } from "./actions"
import {
  getDimensionsApi,
  getTeamsApi,
} from "../../../../../utils/routes/routes-report"

export function* getTeamsSaga(action) {
  try {
    const dataStatus = action.payload
    const [
      { data: dimensionsApi, metric_total: metricTotal },
      { data: teamsApi },
    ] = yield all([
      call(getDimensionsApi, dataStatus),
      call(getTeamsApi, dataStatus),
    ])

    const result = {}
    result.metric_total = metricTotal
    result.teams = teamsApi
    result.dimensions = dimensionsApi
    result.teams_drill_down =
      teamsApi.length > 0
        ? generateTree("id_position", "id_position_parent", teamsApi)
        : []

    yield put(getTeamsSuccess(result))
  } catch (e) {
    yield put(getTeamsFailed())
  }
}

// Individual exports for testing
export default function* widgetResultByTeam() {
  yield takeLatest(GET_TEAMS_WATCHER, getTeamsSaga)
}
